/*=====================================
    更新發票資訊

    Author: Ac
    createtime: 2018 / 12 / 07
=====================================*/

/*--------------------------
    Import
--------------------------*/
import React, { PureComponent } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import styled from 'styled-components';
import { GlobalStyle, MemberStyle, Colors, Button } from 'stylecomponents';
import TopbarView from "components/commons/TopbarView";
import CupoyRouter from "components/commons/router/CupoyRouter";
import CupoySrefView from "components/commons/router/CupoySrefView";
import GLOBAL from 'nonnmwebglobal';
import CupoyLink from 'components/commons/CupoyLink';
import NPOBAN_LIST from 'json/npobanlist.json';
import mobileUtil from 'util/mobileUtil';
import NeedLoginBlock from 'components/commons/status/NeedLoginBlock';
import { CancelToken } from 'axios';

/*--------------------------
    Style Component
--------------------------*/
const SubmitLoading = styled.div`
    position: absolute;
    display: flex;
    top: 0;
    left: 16px;
    height: 100%;
    align-items: center;
    justify-content: center;
`;
const RegionTitleNotice = styled.span`
    margin-left: 10px;
    color: ${Colors.Main};
    font-size: 15px;
`;
const RegionTitle = styled.div`
    align-items: center;
    margin : ${props => props.margin ? props.margin : '6px 0 0 0'};;
    font-size: 20px;
    color: #333333;
`;
const CheckBox = styled.div`
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width : 18px;
    height : 18px;
    line-height: 18px;
    border-radius: 0 3px 0 3px;
    background-color: ${Colors.Orange};
    text-align: center;
    color: #fff;
    font-size: 16px;
`;
const CheckRetangle = styled.div`
    position: relative;
    height: 44px;
    line-height: 44px;
    border-radius: 3px;
    border : 1px solid ${(props) => props.isCheck ? Colors.Orange : '#CCC'};
    flex: 1;
    text-align: center;
    background-color: #FFFFFF;
    font-size: 14px;
    color: ${(props) => props.isCheck ? Colors.Orange : '#6A6A6A'};
    letter-spacing: 0;
    text-align: center;
    cursor : pointer;

    &:first-child {
        margin: 0 10px 0 0;
    }

    ${CheckBox} {
        ${(props) => {
            if(props.isCheck) {
                return `display: block`;
            }
        }}
    }
`;
const LineDelimeter = styled.div`
    margin : 16px 0 0 0;
    border-top : 1px solid #DDD;
    width : 100%;
    height : 1px;
`;
const InvoiceNoitceLink = styled.span`
    margin-left: 5px;
    color: ${Colors.Main};
    font-size: 12px;
`;
const FieldTitle = styled(MemberStyle.FieldTitle)`
    display: block;
    margin-top: 16px;

    > span {
        display: inline-flex;
        align-items: center;
        color: ${Colors.Red};
        margin-left: 4px;
    }
`;
const JoinMemberCarrierBtn = styled(Button.Blue)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: calc(50% - 5px);
    margin-top: 16px;

    ${GlobalStyle.Spin} {
        margin: 0 6px 0 0;
    }
`;

/*--------------------------
    Main Component
--------------------------*/
class UpdateInvoiceView extends PureComponent {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        const {
            memberinfo = {},
        } = props;

        const {
            isdonate,
            npoban,
            carriertype,
            carrierid,
            invoicetype,
            crn,
            companytitle,
        } = memberinfo;

        this.state = {
            isError : false,
            isLoading: false,
            errorMap: {},
            isdonate: !!isdonate,
            npoban: npoban ? npoban.trim() : '',
            carriertype: invoicetype === 1 ? (carriertype || GLOBAL.CARRIER_TYPE.MEMBER) : (carriertype || GLOBAL.CARRIER_TYPE.NONE),
            carrierid: carrierid ? carrierid.trim() : '',
            isChkingCarrierId: false,
            isChkCarrierIdError: false,
            invoicetype: invoicetype || 1,
            crn: crn || '',
            companytitle: companytitle || '',
        }

        this.changeDonateToTrue = this.changeDonate.bind(this, true);
        this.changeDonateToFalse = this.changeDonate.bind(this, false);
        this.changeCarriertypeToMember = this.changeCarriertype.bind(this, GLOBAL.CARRIER_TYPE.MEMBER);
        this.changeCarriertypeToCommon = this.changeCarriertype.bind(this, GLOBAL.CARRIER_TYPE.COMMONS);
        this.checkCarrierId = this.checkCarrierId.bind(this);
        this.joinMemberCarrier = this.joinMemberCarrier.bind(this);
        this.changeInvoicetypeToType1 = this.changeInvoicetype.bind(this, 1);
        this.changeInvoicetypeToType2 = this.changeInvoicetype.bind(this, 2);

        this.chkCarrierIdController = null;
    }

    changeInvoicetype = type => {

        if (this.chkCarrierIdController) {
            this.chkCarrierIdController.cancel();
        }

        if (type === 1) { // 個人電子發票
            this.setState({
                invoicetype: type,
                crn: '',
                companytitle: '',
                carriertype:GLOBAL.CARRIER_TYPE.MEMBER,
                isChkingCarrierId: false,
                isChkCarrierIdError: false,
            });
        } else { // 公司電子發票
            this.setState({
                invoicetype: type,
                isdonate: false, // 公司電子發票不能捐贈
                npoban: '',
                carriertype: GLOBAL.CARRIER_TYPE.NONE, // 預設不使用載具
                carrierid: '',
                isChkingCarrierId: false,
                isChkCarrierIdError: false,
            });
        }
    }

    handleCrnChange = event => {
        this.setState ({
            crn: event.target.value
        });
    }

    handleCompanytitleChange = event => {
        this.setState ({
            companytitle: event.target.value
        });
    }

    changeCarriertype = type => {

        if (this.chkCarrierIdController) {
            this.chkCarrierIdController.cancel();
        }

        this.setState({
            carriertype: type,
            carrierid: '',
            isChkingCarrierId: false,
            isChkCarrierIdError: false,
        });
    }

    changeDonate = isdonate => {

        if (isdonate === this.state.isdonate) {
            return;
        }

        this.setState({
            isdonate: isdonate,
            npoban: !isdonate ? '' : this.state.npoban, // Clear npoban when changing to not-donate
        });
    }

    handleNicknameChange = event => {
        this.setState ({ nickname : event.target.value });
    }

    update = () => {

        const {
            membername,
            nickname,
            birthday,
            shownametype,
            address,
            sex,
        } = this.props.memberinfo;

        const {
            isdonate,
            npoban = '',
            carriertype,
            carrierid = '',
            isLoading,
            isChkingCarrierId,
            isChkCarrierIdError,
            invoicetype,
            crn,
            companytitle,
        } = this.state;

        if (isLoading || isChkingCarrierId || isChkCarrierIdError) {
            return;
        }

        let message = '';
        let isError =  false;
        let objInput = null;
        let errorMap = {};

        if (invoicetype === 1) { // 個人電子發票
            if (isdonate) {
                if (!NPOBAN_LIST[npoban] || GLOBAL.isEmpty(npoban)) {
                    isError = true;
                    message += "請輸入正確的捐贈碼\n";
                    objInput = objInput || this.npobanInput;
                    errorMap['npoban'] = true;
                }
            } else if (carriertype === GLOBAL.CARRIER_TYPE.COMMONS) {
                if (GLOBAL.isEmpty(carrierid)) {
                    isError = true;
                    message += "請輸入共通性載具ID\n";
                    objInput = objInput || this.carrieridInput;
                    errorMap['carrierid'] = true;
                } else if (!GLOBAL.isMobilePhoneCarrierID(carrierid) && !GLOBAL.isDigitalCitizenCarrierID(carrierid)) {
                    isError = true;
                    message += "個人電子發票發票載具ID為手機條碼(8碼)或自然人憑證(16碼)\n";
                    objInput = objInput || this.carrieridInput;
                    errorMap['carrierid'] = true;
                }
            }
        } else if (invoicetype === 2) { // 公司電子發票
            // Use the new validation logic
            if (!this.isValidGuino(crn, invoicetype)) {
                isError = true;
                message += "請輸入正確的8碼公司統編\n"; // Updated error message for clarity
                objInput = objInput || this.crnInput;
                errorMap['crn'] = true;
            }            if (GLOBAL.isEmpty(companytitle)) {
                isError = true;
                message += "請輸入公司抬頭\n";
                objInput = objInput || this.companytitleInput;
                errorMap['companytitle'] = true;
            }
            if (carriertype === GLOBAL.CARRIER_TYPE.COMMONS) {
                if (GLOBAL.isEmpty(carrierid)) {
                    isError = true;
                    message += "請輸入共通性載具ID\n";
                    objInput = objInput || this.carrieridInput;
                    errorMap['carrierid'] = true;
                } else if (!GLOBAL.isMobilePhoneCarrierID(carrierid)) {
                    isError = true;
                    message += "公司電子發票發票載具ID僅能為手機條碼(8碼)\n";
                    objInput = objInput || this.carrieridInput;
                    errorMap['carrierid'] = true;
                }
            }
        }

        if(isError){
            this.setState({
                errorMap: errorMap,
            }, () => {
                this.props.webActions.openAlertDialog({
                    title: "錯誤訊息",
                    description : message,
                    closeName: '確定',
                    closeCallback: () => {
                        if (objInput) objInput.focus();
                    }
                });
            })
            return;
        }

        const addressMap = GLOBAL.parseAddress(address);

        this.setState({ isLoading: true }, () => {
            const payload = {
                city: addressMap.city,
                region: addressMap.region,
                postalcode: addressMap.zipcode,
                addreGss: addressMap.address,
                name: membername,
                nickname,
                birthday,
                isdonate,
                npoban: npoban.trim(),
                carrierid: carrierid.trim(),
                carriertype,
                invoicetype,
                crn,
                companytitle,
                shownametype,
                sex,
            };

            this.props.memberActions.updMember(payload).then((result) => {
                this.setState({ isLoading: false }, () => {
                    if(result)
                        this.props.webActions.openAlertDialog({
                            title: '發票資訊修改成功',
                            closeCallback: () => {
                                this.props.webActions.cupoyStateGo(CupoyRouter.STATES.MEMBER_INVOICE);
                            }
                        });
                });
            }).catch((error) => {
                this.setState({
                    isError: true,
                    isLoading: false
                }, () => {
                    this.props.webActions.openAlertDialog({
                        title: '發生錯誤',
                        description: error && error.message
                            ? error.message
                            : '無法成功修改發票資訊，請稍後再嘗試。',
                    });
                });
            });
        });
    }

    // ------------------------------
    // 未登入的畫面
    // ------------------------------
    renderNoLoginContent() {
        return <NeedLoginBlock />;
    }

    handleNpobanberChange = event => {
        this.setState({
            npoban: event.target.value,
        });
    }

    checkCarrierId() {

        const {
            carrierid,
        } = this.state;

        const _carrierid = carrierid.trim();

        if (this.chkCarrierIdController) {
            this.chkCarrierIdController.cancel();
        }

        // 沒有id，直接顯示錯誤
        if (!_carrierid) {
            this.setState({
                isChkingCarrierId: false,
                isChkCarrierIdError: true,
            });
            return;
        }

        // 格式是合法的自然人憑證id，pass
        if (GLOBAL.isDigitalCitizenCarrierID(_carrierid)) {
            this.setState({
                isChkingCarrierId: false,
                isChkCarrierIdError: false,
            });
            return;
        }

        // 格式不是合法的手機條碼，直接不檢查，顯示錯誤
        if (!GLOBAL.isMobilePhoneCarrierID(_carrierid)) {
            this.setState({
                isChkingCarrierId: false,
                isChkCarrierIdError: true,
            });
            return;
        }

        this.chkCarrierIdController = CancelToken.source();
        const { token: cancelToken } = this.chkCarrierIdController;

        this.setState({
            isChkingCarrierId: true,
            isChkCarrierIdError: false,
        }, () => {
            this.props.webActions.checkEinvoiceMobileCarrier({
                carrierid: _carrierid,
                cancelToken,
            }).then(() => {
                this.setState({
                    isChkingCarrierId: false,
                });
            }).catch(() => {
                this.setState({
                    isChkingCarrierId: false,
                    isChkCarrierIdError: true,
                });
            });
        });
    }

    handleCarrieridChange = event => {
        this.setState({
            carrierid: event.target.value,
        }, this.checkCarrierId);
    }

    joinMemberCarrier() {

        if (this.state.isJoinMemberCarrierLoading) {
            return;
        }

        this.setState({
            isJoinMemberCarrierLoading: true,
        });

        this.props.memberActions.joinMemberCarrier(
        ).catch(error => {

            this.setState({
                isJoinMemberCarrierLoading: false,
            });

            this.props.webActions.openAlertDialog({
                title: '發生錯誤',
                description: error && error.message
                    ? error.message
                    : '發生無法預期的錯誤，請重新整理稍後再試，或聯絡我們的客服人員',
            });
        });
    }

    // ------------------------------
    // render
    // ------------------------------
    // Helper function for validating company registration number (統編)
    isValidGuino = (guino, invoicetype) => {
        // Only apply this validation if it's for company electronic invoice
        if (invoicetype !== 2) {
            return true; // Not company invoice, so it's valid in this context.
        }

        // Basic validation: must be an 8-digit string
        if (!guino || guino.length !== 8 || !/^\d{8}$/.test(guino)) {
            return false;
        }

        const multipliers = [1, 2, 1, 2, 1, 2, 4, 1];
        // Helper to sum digits of a number (e.g., 18 becomes 1+8=9)
        const sumDigits = (n) => String(n).split('').reduce((sum, digit) => sum + parseInt(digit, 10), 0);

        const seventhDigit = parseInt(guino[6], 10);

        if (seventhDigit !== 7) {
            // Case 1: 7th digit is NOT '7'
            let total = 0;
            for (let i = 0; i < 8; i++) {
                const product = parseInt(guino[i], 10) * multipliers[i];
                total += sumDigits(product);
            }
            return total % 5 === 0;
        } else {
            // Case 2: 7th digit IS '7'
            let total_else = 0; // Sum for digits other than the 7th
            for (let i = 0; i < 8; i++) {
                if (i === 6) continue; // Skip the 7th digit for now
                const product = parseInt(guino[i], 10) * multipliers[i];
                total_else += sumDigits(product);
            }
            // Check with 7th digit's contribution being 1 or 0
            // If either sum is divisible by 5, it's valid
            const sumWithSevenAsOne = total_else + 1;
            const sumWithSevenAsZero = total_else + 0;

            return sumWithSevenAsOne % 5 === 0 || sumWithSevenAsZero % 5 === 0;
        }
    }

    render() {

        const {
            isLoading,
            errorMap,
            isdonate,
            npoban,
            carriertype,
            carrierid,
            isChkingCarrierId,
            isChkCarrierIdError,
            isJoinMemberCarrierLoading,
            invoicetype,
            crn,
            companytitle,
        } = this.state;

        const disableSubmit = isLoading
            || isChkingCarrierId
            || isChkCarrierIdError;

        return (
            <GlobalStyle.Container  hasFixedTopbar  hasFixedTabbar={false}>

                <TopbarView
                    isFixed
                    leftComponent={
                        <CupoySrefView
                            statename={CupoyRouter.STATES.MEMBER_INVOICE}
                            stylecomponent={GlobalStyle.TopbarButton}
                        >
                            <GlobalStyle.TopbarIcon>
                                <i className="zmdi zmdi-chevron-left"></i>
                            </GlobalStyle.TopbarIcon>
                            發票管理
                        </CupoySrefView>
                    }
                    middleComponent="修改發票資訊"
                />

                <MemberStyle.MemberContent>
                    <RegionTitle>發票類型</RegionTitle>
                    <RegionTitleNotice>種類：個人電子發票</RegionTitleNotice>

                    {/* ----- 發票類型 ----- */}
                    {/*
                    <MemberStyle.InputContainer
                        flexdirection="row"
                        justify="space-between"
                    >
                        <CheckRetangle
                            isCheck={invoicetype === 1}
                            onClick={this.changeInvoicetypeToType1}
                        >
                            <CheckBox><i className="zmdi zmdi-check"></i></CheckBox>
                            個人電子發票
                        </CheckRetangle>
                        <CheckRetangle
                            isCheck={invoicetype === 2}
                            onClick={this.changeInvoicetypeToType2}
                        >
                            <CheckBox><i className="zmdi zmdi-check"></i></CheckBox>
                            公司電子發票
                        </CheckRetangle>
                    </MemberStyle.InputContainer>
                        */}
                    <LineDelimeter />

                    {/* ----- 個人電子發票 ----- */}
                    {invoicetype === 1 && (
                        <React.Fragment>
                            {/* ----- 發票載具 ----- */}
                            <FieldTitle>發票載具</FieldTitle>
                            <MemberStyle.InputContainer flexdirection="row" justify="space-between">
                                <CheckRetangle
                                    isCheck={carriertype === GLOBAL.CARRIER_TYPE.MEMBER}
                                    onClick={this.changeCarriertypeToMember}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    會員載具
                                </CheckRetangle>
                                <CheckRetangle
                                    isCheck={carriertype === GLOBAL.CARRIER_TYPE.COMMONS}
                                    onClick={this.changeCarriertypeToCommon}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    共通性載具
                                </CheckRetangle>
                            </MemberStyle.InputContainer>
                            {carriertype === GLOBAL.CARRIER_TYPE.COMMONS && (
                                <React.Fragment>
                                    <FieldTitle>
                                        載具ID
                                        {isChkingCarrierId && <span><GlobalStyle.Spin size='12px' /></span>}
                                        {isChkCarrierIdError && <span> 格式錯誤</span>}
                                    </FieldTitle>
                                    <MemberStyle.MemberInputBox
                                        ref={(input) => { this.carrieridInput = input; }}
                                        type="text"
                                        value={carrierid}
                                        placeholder="手機條碼(8碼)或自然人憑證(16碼)"
                                        margin="8px 0 0 0"
                                        onChange={this.handleCarrieridChange}
                                        error={errorMap['carrierid']}
                                    />
                                </React.Fragment>
                            )}
                            <JoinMemberCarrierBtn
                                disable={isJoinMemberCarrierLoading}
                                onClick={this.joinMemberCarrier}
                            >
                                {isJoinMemberCarrierLoading && (
                                    <GlobalStyle.Spin size='14px' color="#fff"/>
                                )}
                                會員載具歸戶
                            </JoinMemberCarrierBtn>

                            <LineDelimeter />

                            {/* ----- 捐贈發票 ----- */}
                            <FieldTitle>捐贈發票</FieldTitle>
                            <MemberStyle.InputContainer flexdirection="row" justify="space-between">
                                <CheckRetangle
                                    isCheck={isdonate}
                                    onClick={this.changeDonateToTrue}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    捐贈
                                </CheckRetangle>
                                <CheckRetangle
                                    isCheck={!isdonate}
                                    onClick={this.changeDonateToFalse}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    不捐贈
                                </CheckRetangle>
                            </MemberStyle.InputContainer>
                            {isdonate && (
                                <React.Fragment>
                                    <FieldTitle style={{ display: 'inline-block', width: 'auto' }}>
                                        捐贈碼
                                        <a
                                            target='_blank'
                                            rel='noopener noreferrer'
                                            href={`${GLOBAL.URL_PREFIX}/npobanlist.pdf`}
                                            onClick={mobileUtil.handleOpenLinkBridgeWithNew}
                                        >
                                            <InvoiceNoitceLink>【捐贈碼查詢】</InvoiceNoitceLink>
                                        </a>
                                    </FieldTitle>
                                    <MemberStyle.MemberInputBox
                                        ref={(input) => { this.npobanInput = input; }}
                                        type="text"
                                        value={npoban}
                                        placeholder="請輸入捐贈碼"
                                        margin="8px 0 0 0"
                                        onChange={this.handleNpobanberChange}
                                        error={errorMap['npoban']}
                                    />
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}

                    {invoicetype === 2 && (
                        <React.Fragment>
                            <FieldTitle>公司統編</FieldTitle>
                            <MemberStyle.MemberInputBox
                                ref={(input) => { this.crnInput = input; }}
                                type="text"
                                value={crn}
                                placeholder="必填, 8碼"
                                margin="8px 0 0 0"
                                onChange={this.handleCrnChange}
                                error={errorMap['crn']}
                                maxLength="8"
                                onFocus={(e) => {
                                    // If the crn state is empty (meaning the placeholder "必填, 8碼" is showing),
                                    // set the cursor to the beginning of the input.
                                    if (!e.target.value) {
                                        e.target.setSelectionRange(0, 0);
                                    }
                                }}
                            />
                            <FieldTitle>公司抬頭</FieldTitle>
                            <MemberStyle.MemberInputBox
                                ref={(input) => { this.companytitleInput = input; }}
                                type="text"
                                value={companytitle}
                                placeholder="必填"
                                margin="8px 0 0 0"
                                onChange={this.handleCompanytitleChange}
                                error={errorMap['companytitle']}
                            />

                            <LineDelimeter />

                            <FieldTitle>發票載具</FieldTitle>
                            <MemberStyle.InputContainer flexdirection="row" justify="space-between">
                                <CheckRetangle
                                    isCheck={carriertype === GLOBAL.CARRIER_TYPE.NONE}
                                    onClick={() => this.changeCarriertype(GLOBAL.CARRIER_TYPE.NONE)}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    不使用
                                </CheckRetangle>
                                <CheckRetangle
                                    isCheck={carriertype === GLOBAL.CARRIER_TYPE.COMMONS}
                                    onClick={this.changeCarriertypeToCommon}
                                >
                                    <CheckBox><i className="zmdi zmdi-check" /></CheckBox>
                                    共通性載具
                                </CheckRetangle>
                            </MemberStyle.InputContainer>

                            {carriertype === GLOBAL.CARRIER_TYPE.COMMONS && (
                                <React.Fragment>
                                    <FieldTitle>
                                        載具ID
                                        {isChkingCarrierId && <span><GlobalStyle.Spin size='12px' /></span>}
                                        {isChkCarrierIdError && <span> 格式錯誤</span>}
                                    </FieldTitle>
                                    <MemberStyle.MemberInputBox
                                        ref={(input) => { this.carrieridInput = input; }}
                                        type="text"
                                        value={carrierid}
                                        placeholder="僅能輸入手機條碼8碼"
                                        margin="8px 0 0 0"
                                        onChange={this.handleCarrieridChange}
                                        error={errorMap['carrierid']}
                                        maxLength="8"
                                    />
                                </React.Fragment>
                            )

                            }
                        </React.Fragment>
                    )}
                </MemberStyle.MemberContent>
                <MemberStyle.BottomBar>
                    <MemberStyle.ConfirmBtn
                        margin="0"
                        disable={disableSubmit}
                        onClick={this.update}
                    >
                        {isLoading && (
                            <SubmitLoading>
                                <GlobalStyle.Spin color="#fff"/>
                            </SubmitLoading>
                        )}
                        完成
                    </MemberStyle.ConfirmBtn>
                </MemberStyle.BottomBar>
            </GlobalStyle.Container>

        )
    };

}

/*--------------------------
    export
--------------------------*/

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {

    return {
        memberinfo : state.member.memberinfo,
        haslogin: state.member.haslogin,
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
    return {
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
        memberActions: bindActionCreators(actionCreators.memberActionCreators, dispatch),
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    forwardRef: true
})(UpdateInvoiceView);